import { apiErrorCode } from '../../utils/apiError';

/**
 * Soft delete + restore of a video (s3_files.deactivated). DELETE /videos/:id
 * hides the video; PATCH /files/:id { deactivated: false } brings it back.
 * Both are admin | account manager admin (isAM) on the API.
 */

/** The error code of a failed request. control()-wrapped routes send a bare
 *  code string ("FileNotDeleted") when there are no details, others send
 *  { error }. A string body that isn't a code (an HTML error page) is ignored. */
export const softDeleteErrorCode = (err: any): string | undefined => {
  const code = apiErrorCode(err);
  return code && /^[A-Za-z_]+$/.test(code) ? code : undefined;
};

/** The toast text for a failed delete/restore: the server's message, then its
 *  error code (as `codeCopy` words it, if it does), then the transport error. */
export const softDeleteErrorMessage = (
  err: any,
  fallback: string,
  codeCopy: Record<string, string> = {}
): string => {
  const message = err?.response?.data?.message;
  if (typeof message === 'string' && message) return message;
  const code = softDeleteErrorCode(err);
  if (code) return codeCopy[code] || code;
  return err?.message || fallback;
};

/** Where an admin finds a deleted video again (the section's toggle label). */
export const DELETED_TOGGLE_LABEL = 'Deleted only';
